<div class="container-tree">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="tree">
    <!-- Unique node -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
      <li class="mat-tree-node">
        <button mat-icon-button disabled></button>
        <!-- Node -->
        <div class="tree-node" [ngClass]="{active: node.active}" (click)="selectNode(node)">
          <span class="mat-tree-node-name">{{node.name}}</span>
        </div>
        <!-- Menu kebab -->
        <button *ngIf="node.active" mat-button [matMenuTriggerFor]="menu">
          {{optionSelected}}
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item  (click)="onAccountSelected(node.id, false)">Cuenta actual</button>
        </mat-menu> 
      </li>
    </mat-tree-node>
    <!-- Nested tree node -->
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" class="child-nested-tree">
      <li>
        <div class="mat-tree-node parent-child-tree">
          <button mat-icon-button matTreeNodeToggle
                  [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <!-- Node -->
          <div  class="tree-node" [ngClass]="{active: node.active}" (click)="selectNode(node)">
            <span class="mat-tree-node-name">{{node.name}}</span>
          </div>
          <!-- Menu kebab -->
          <button *ngIf="node.active" mat-button [matMenuTriggerFor]="menu">
            {{optionSelected}}
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item  
              (click)="onAccountSelected(node.id, true)">
              Todas las cuentas
            </button> 
            <button mat-menu-item  (click)="onAccountSelected(node.id, false)">Cuenta actual</button>
          </mat-menu>      
        </div>
        <ul [class.tree-invisible]="!treeControl.isExpanded(node)">
          <ng-container matTreeNodeOutlet></ng-container>
        </ul>
      </li>
    </mat-nested-tree-node>
  </mat-tree>
</div>